/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WaitlistImport } from './routes/waitlist'
import { Route as AuthedImport } from './routes/_authed'
import { Route as SignInSplatImport } from './routes/sign-in.$'
import { Route as AuthCallbackImport } from './routes/auth.callback'
import { Route as AuthedInstallImport } from './routes/_authed/install'
import { Route as AuthedLayoutImport } from './routes/_authed/_layout'
import { Route as AuthedLayoutIndexImport } from './routes/_authed/_layout/index'
import { Route as AuthedOnboardingOwnerImport } from './routes/_authed/onboarding.$owner'
import { Route as AuthedInstallationCallbackImport } from './routes/_authed/installation.callback'
import { Route as AuthedLayoutTestImport } from './routes/_authed/_layout/test'
import { Route as AuthedLayoutAdminImport } from './routes/_authed/_layout/admin'
import { Route as AuthedLayoutOwnerImport } from './routes/_authed/_layout/$owner'
import { Route as AuthedLayoutPullsIndexImport } from './routes/_authed/_layout/pulls/index'
import { Route as AuthedLayoutAdminIndexImport } from './routes/_authed/_layout/admin/index'
import { Route as AuthedLayoutPullsNewImport } from './routes/_authed/_layout/pulls/new'
import { Route as AuthedLayoutOwnerSettingsImport } from './routes/_authed/_layout/$owner.settings'
import { Route as AuthedLayoutOwnerSettingsIndexImport } from './routes/_authed/_layout/$owner.settings/index'
import { Route as AuthedLayoutOwnerSettingsReviewImport } from './routes/_authed/_layout/$owner.settings/review'
import { Route as AuthedLayoutOwnerSettingsPullRequestsImport } from './routes/_authed/_layout/$owner.settings/pull-requests'
import { Route as AuthedLayoutOwnerSettingsMembersImport } from './routes/_authed/_layout/$owner.settings/members'
import { Route as AuthedLayoutOwnerSettingsAgentsImport } from './routes/_authed/_layout/$owner.settings/agents'
import { Route as AuthedLayoutOwnerRepoPullNumberImport } from './routes/_authed/_layout/$owner.$repo.pull.$number'

// Create/Update Routes

const WaitlistRoute = WaitlistImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRoute,
} as any)

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any)

const SignInSplatRoute = SignInSplatImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthedInstallRoute = AuthedInstallImport.update({
  id: '/install',
  path: '/install',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLayoutRoute = AuthedLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLayoutIndexRoute = AuthedLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedOnboardingOwnerRoute = AuthedOnboardingOwnerImport.update({
  id: '/onboarding/$owner',
  path: '/onboarding/$owner',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedInstallationCallbackRoute = AuthedInstallationCallbackImport.update(
  {
    id: '/installation/callback',
    path: '/installation/callback',
    getParentRoute: () => AuthedRoute,
  } as any,
)

const AuthedLayoutTestRoute = AuthedLayoutTestImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedLayoutAdminRoute = AuthedLayoutAdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedLayoutOwnerRoute = AuthedLayoutOwnerImport.update({
  id: '/$owner',
  path: '/$owner',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedLayoutPullsIndexRoute = AuthedLayoutPullsIndexImport.update({
  id: '/pulls/',
  path: '/pulls/',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedLayoutAdminIndexRoute = AuthedLayoutAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedLayoutAdminRoute,
} as any)

const AuthedLayoutPullsNewRoute = AuthedLayoutPullsNewImport.update({
  id: '/pulls/new',
  path: '/pulls/new',
  getParentRoute: () => AuthedLayoutRoute,
} as any)

const AuthedLayoutOwnerSettingsRoute = AuthedLayoutOwnerSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedLayoutOwnerRoute,
} as any)

const AuthedLayoutOwnerSettingsIndexRoute =
  AuthedLayoutOwnerSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedLayoutOwnerSettingsRoute,
  } as any)

const AuthedLayoutOwnerSettingsReviewRoute =
  AuthedLayoutOwnerSettingsReviewImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthedLayoutOwnerSettingsRoute,
  } as any)

const AuthedLayoutOwnerSettingsPullRequestsRoute =
  AuthedLayoutOwnerSettingsPullRequestsImport.update({
    id: '/pull-requests',
    path: '/pull-requests',
    getParentRoute: () => AuthedLayoutOwnerSettingsRoute,
  } as any)

const AuthedLayoutOwnerSettingsMembersRoute =
  AuthedLayoutOwnerSettingsMembersImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthedLayoutOwnerSettingsRoute,
  } as any)

const AuthedLayoutOwnerSettingsAgentsRoute =
  AuthedLayoutOwnerSettingsAgentsImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthedLayoutOwnerSettingsRoute,
  } as any)

const AuthedLayoutOwnerRepoPullNumberRoute =
  AuthedLayoutOwnerRepoPullNumberImport.update({
    id: '/$repo/pull/$number',
    path: '/$repo/pull/$number',
    getParentRoute: () => AuthedLayoutOwnerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedImport
      parentRoute: typeof rootRoute
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistImport
      parentRoute: typeof rootRoute
    }
    '/_authed/_layout': {
      id: '/_authed/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedLayoutImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/install': {
      id: '/_authed/install'
      path: '/install'
      fullPath: '/install'
      preLoaderRoute: typeof AuthedInstallImport
      parentRoute: typeof AuthedImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatImport
      parentRoute: typeof rootRoute
    }
    '/_authed/_layout/$owner': {
      id: '/_authed/_layout/$owner'
      path: '/$owner'
      fullPath: '/$owner'
      preLoaderRoute: typeof AuthedLayoutOwnerImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/_layout/admin': {
      id: '/_authed/_layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedLayoutAdminImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/_layout/test': {
      id: '/_authed/_layout/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof AuthedLayoutTestImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/installation/callback': {
      id: '/_authed/installation/callback'
      path: '/installation/callback'
      fullPath: '/installation/callback'
      preLoaderRoute: typeof AuthedInstallationCallbackImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/onboarding/$owner': {
      id: '/_authed/onboarding/$owner'
      path: '/onboarding/$owner'
      fullPath: '/onboarding/$owner'
      preLoaderRoute: typeof AuthedOnboardingOwnerImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/_layout/': {
      id: '/_authed/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedLayoutIndexImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/_layout/$owner/settings': {
      id: '/_authed/_layout/$owner/settings'
      path: '/settings'
      fullPath: '/$owner/settings'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsImport
      parentRoute: typeof AuthedLayoutOwnerImport
    }
    '/_authed/_layout/pulls/new': {
      id: '/_authed/_layout/pulls/new'
      path: '/pulls/new'
      fullPath: '/pulls/new'
      preLoaderRoute: typeof AuthedLayoutPullsNewImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/_layout/admin/': {
      id: '/_authed/_layout/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedLayoutAdminIndexImport
      parentRoute: typeof AuthedLayoutAdminImport
    }
    '/_authed/_layout/pulls/': {
      id: '/_authed/_layout/pulls/'
      path: '/pulls'
      fullPath: '/pulls'
      preLoaderRoute: typeof AuthedLayoutPullsIndexImport
      parentRoute: typeof AuthedLayoutImport
    }
    '/_authed/_layout/$owner/settings/agents': {
      id: '/_authed/_layout/$owner/settings/agents'
      path: '/agents'
      fullPath: '/$owner/settings/agents'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsAgentsImport
      parentRoute: typeof AuthedLayoutOwnerSettingsImport
    }
    '/_authed/_layout/$owner/settings/members': {
      id: '/_authed/_layout/$owner/settings/members'
      path: '/members'
      fullPath: '/$owner/settings/members'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsMembersImport
      parentRoute: typeof AuthedLayoutOwnerSettingsImport
    }
    '/_authed/_layout/$owner/settings/pull-requests': {
      id: '/_authed/_layout/$owner/settings/pull-requests'
      path: '/pull-requests'
      fullPath: '/$owner/settings/pull-requests'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsPullRequestsImport
      parentRoute: typeof AuthedLayoutOwnerSettingsImport
    }
    '/_authed/_layout/$owner/settings/review': {
      id: '/_authed/_layout/$owner/settings/review'
      path: '/review'
      fullPath: '/$owner/settings/review'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsReviewImport
      parentRoute: typeof AuthedLayoutOwnerSettingsImport
    }
    '/_authed/_layout/$owner/settings/': {
      id: '/_authed/_layout/$owner/settings/'
      path: '/'
      fullPath: '/$owner/settings/'
      preLoaderRoute: typeof AuthedLayoutOwnerSettingsIndexImport
      parentRoute: typeof AuthedLayoutOwnerSettingsImport
    }
    '/_authed/_layout/$owner/$repo/pull/$number': {
      id: '/_authed/_layout/$owner/$repo/pull/$number'
      path: '/$repo/pull/$number'
      fullPath: '/$owner/$repo/pull/$number'
      preLoaderRoute: typeof AuthedLayoutOwnerRepoPullNumberImport
      parentRoute: typeof AuthedLayoutOwnerImport
    }
  }
}

// Create and export the route tree

interface AuthedLayoutOwnerSettingsRouteChildren {
  AuthedLayoutOwnerSettingsAgentsRoute: typeof AuthedLayoutOwnerSettingsAgentsRoute
  AuthedLayoutOwnerSettingsMembersRoute: typeof AuthedLayoutOwnerSettingsMembersRoute
  AuthedLayoutOwnerSettingsPullRequestsRoute: typeof AuthedLayoutOwnerSettingsPullRequestsRoute
  AuthedLayoutOwnerSettingsReviewRoute: typeof AuthedLayoutOwnerSettingsReviewRoute
  AuthedLayoutOwnerSettingsIndexRoute: typeof AuthedLayoutOwnerSettingsIndexRoute
}

const AuthedLayoutOwnerSettingsRouteChildren: AuthedLayoutOwnerSettingsRouteChildren =
  {
    AuthedLayoutOwnerSettingsAgentsRoute: AuthedLayoutOwnerSettingsAgentsRoute,
    AuthedLayoutOwnerSettingsMembersRoute:
      AuthedLayoutOwnerSettingsMembersRoute,
    AuthedLayoutOwnerSettingsPullRequestsRoute:
      AuthedLayoutOwnerSettingsPullRequestsRoute,
    AuthedLayoutOwnerSettingsReviewRoute: AuthedLayoutOwnerSettingsReviewRoute,
    AuthedLayoutOwnerSettingsIndexRoute: AuthedLayoutOwnerSettingsIndexRoute,
  }

const AuthedLayoutOwnerSettingsRouteWithChildren =
  AuthedLayoutOwnerSettingsRoute._addFileChildren(
    AuthedLayoutOwnerSettingsRouteChildren,
  )

interface AuthedLayoutOwnerRouteChildren {
  AuthedLayoutOwnerSettingsRoute: typeof AuthedLayoutOwnerSettingsRouteWithChildren
  AuthedLayoutOwnerRepoPullNumberRoute: typeof AuthedLayoutOwnerRepoPullNumberRoute
}

const AuthedLayoutOwnerRouteChildren: AuthedLayoutOwnerRouteChildren = {
  AuthedLayoutOwnerSettingsRoute: AuthedLayoutOwnerSettingsRouteWithChildren,
  AuthedLayoutOwnerRepoPullNumberRoute: AuthedLayoutOwnerRepoPullNumberRoute,
}

const AuthedLayoutOwnerRouteWithChildren =
  AuthedLayoutOwnerRoute._addFileChildren(AuthedLayoutOwnerRouteChildren)

interface AuthedLayoutAdminRouteChildren {
  AuthedLayoutAdminIndexRoute: typeof AuthedLayoutAdminIndexRoute
}

const AuthedLayoutAdminRouteChildren: AuthedLayoutAdminRouteChildren = {
  AuthedLayoutAdminIndexRoute: AuthedLayoutAdminIndexRoute,
}

const AuthedLayoutAdminRouteWithChildren =
  AuthedLayoutAdminRoute._addFileChildren(AuthedLayoutAdminRouteChildren)

interface AuthedLayoutRouteChildren {
  AuthedLayoutOwnerRoute: typeof AuthedLayoutOwnerRouteWithChildren
  AuthedLayoutAdminRoute: typeof AuthedLayoutAdminRouteWithChildren
  AuthedLayoutTestRoute: typeof AuthedLayoutTestRoute
  AuthedLayoutIndexRoute: typeof AuthedLayoutIndexRoute
  AuthedLayoutPullsNewRoute: typeof AuthedLayoutPullsNewRoute
  AuthedLayoutPullsIndexRoute: typeof AuthedLayoutPullsIndexRoute
}

const AuthedLayoutRouteChildren: AuthedLayoutRouteChildren = {
  AuthedLayoutOwnerRoute: AuthedLayoutOwnerRouteWithChildren,
  AuthedLayoutAdminRoute: AuthedLayoutAdminRouteWithChildren,
  AuthedLayoutTestRoute: AuthedLayoutTestRoute,
  AuthedLayoutIndexRoute: AuthedLayoutIndexRoute,
  AuthedLayoutPullsNewRoute: AuthedLayoutPullsNewRoute,
  AuthedLayoutPullsIndexRoute: AuthedLayoutPullsIndexRoute,
}

const AuthedLayoutRouteWithChildren = AuthedLayoutRoute._addFileChildren(
  AuthedLayoutRouteChildren,
)

interface AuthedRouteChildren {
  AuthedLayoutRoute: typeof AuthedLayoutRouteWithChildren
  AuthedInstallRoute: typeof AuthedInstallRoute
  AuthedInstallationCallbackRoute: typeof AuthedInstallationCallbackRoute
  AuthedOnboardingOwnerRoute: typeof AuthedOnboardingOwnerRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedLayoutRoute: AuthedLayoutRouteWithChildren,
  AuthedInstallRoute: AuthedInstallRoute,
  AuthedInstallationCallbackRoute: AuthedInstallationCallbackRoute,
  AuthedOnboardingOwnerRoute: AuthedOnboardingOwnerRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthedLayoutRouteWithChildren
  '/waitlist': typeof WaitlistRoute
  '/install': typeof AuthedInstallRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/$owner': typeof AuthedLayoutOwnerRouteWithChildren
  '/admin': typeof AuthedLayoutAdminRouteWithChildren
  '/test': typeof AuthedLayoutTestRoute
  '/installation/callback': typeof AuthedInstallationCallbackRoute
  '/onboarding/$owner': typeof AuthedOnboardingOwnerRoute
  '/': typeof AuthedLayoutIndexRoute
  '/$owner/settings': typeof AuthedLayoutOwnerSettingsRouteWithChildren
  '/pulls/new': typeof AuthedLayoutPullsNewRoute
  '/admin/': typeof AuthedLayoutAdminIndexRoute
  '/pulls': typeof AuthedLayoutPullsIndexRoute
  '/$owner/settings/agents': typeof AuthedLayoutOwnerSettingsAgentsRoute
  '/$owner/settings/members': typeof AuthedLayoutOwnerSettingsMembersRoute
  '/$owner/settings/pull-requests': typeof AuthedLayoutOwnerSettingsPullRequestsRoute
  '/$owner/settings/review': typeof AuthedLayoutOwnerSettingsReviewRoute
  '/$owner/settings/': typeof AuthedLayoutOwnerSettingsIndexRoute
  '/$owner/$repo/pull/$number': typeof AuthedLayoutOwnerRepoPullNumberRoute
}

export interface FileRoutesByTo {
  '': typeof AuthedRouteWithChildren
  '/waitlist': typeof WaitlistRoute
  '/install': typeof AuthedInstallRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/$owner': typeof AuthedLayoutOwnerRouteWithChildren
  '/test': typeof AuthedLayoutTestRoute
  '/installation/callback': typeof AuthedInstallationCallbackRoute
  '/onboarding/$owner': typeof AuthedOnboardingOwnerRoute
  '/': typeof AuthedLayoutIndexRoute
  '/pulls/new': typeof AuthedLayoutPullsNewRoute
  '/admin': typeof AuthedLayoutAdminIndexRoute
  '/pulls': typeof AuthedLayoutPullsIndexRoute
  '/$owner/settings/agents': typeof AuthedLayoutOwnerSettingsAgentsRoute
  '/$owner/settings/members': typeof AuthedLayoutOwnerSettingsMembersRoute
  '/$owner/settings/pull-requests': typeof AuthedLayoutOwnerSettingsPullRequestsRoute
  '/$owner/settings/review': typeof AuthedLayoutOwnerSettingsReviewRoute
  '/$owner/settings': typeof AuthedLayoutOwnerSettingsIndexRoute
  '/$owner/$repo/pull/$number': typeof AuthedLayoutOwnerRepoPullNumberRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/waitlist': typeof WaitlistRoute
  '/_authed/_layout': typeof AuthedLayoutRouteWithChildren
  '/_authed/install': typeof AuthedInstallRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/_authed/_layout/$owner': typeof AuthedLayoutOwnerRouteWithChildren
  '/_authed/_layout/admin': typeof AuthedLayoutAdminRouteWithChildren
  '/_authed/_layout/test': typeof AuthedLayoutTestRoute
  '/_authed/installation/callback': typeof AuthedInstallationCallbackRoute
  '/_authed/onboarding/$owner': typeof AuthedOnboardingOwnerRoute
  '/_authed/_layout/': typeof AuthedLayoutIndexRoute
  '/_authed/_layout/$owner/settings': typeof AuthedLayoutOwnerSettingsRouteWithChildren
  '/_authed/_layout/pulls/new': typeof AuthedLayoutPullsNewRoute
  '/_authed/_layout/admin/': typeof AuthedLayoutAdminIndexRoute
  '/_authed/_layout/pulls/': typeof AuthedLayoutPullsIndexRoute
  '/_authed/_layout/$owner/settings/agents': typeof AuthedLayoutOwnerSettingsAgentsRoute
  '/_authed/_layout/$owner/settings/members': typeof AuthedLayoutOwnerSettingsMembersRoute
  '/_authed/_layout/$owner/settings/pull-requests': typeof AuthedLayoutOwnerSettingsPullRequestsRoute
  '/_authed/_layout/$owner/settings/review': typeof AuthedLayoutOwnerSettingsReviewRoute
  '/_authed/_layout/$owner/settings/': typeof AuthedLayoutOwnerSettingsIndexRoute
  '/_authed/_layout/$owner/$repo/pull/$number': typeof AuthedLayoutOwnerRepoPullNumberRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/waitlist'
    | '/install'
    | '/auth/callback'
    | '/sign-in/$'
    | '/$owner'
    | '/admin'
    | '/test'
    | '/installation/callback'
    | '/onboarding/$owner'
    | '/'
    | '/$owner/settings'
    | '/pulls/new'
    | '/admin/'
    | '/pulls'
    | '/$owner/settings/agents'
    | '/$owner/settings/members'
    | '/$owner/settings/pull-requests'
    | '/$owner/settings/review'
    | '/$owner/settings/'
    | '/$owner/$repo/pull/$number'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/waitlist'
    | '/install'
    | '/auth/callback'
    | '/sign-in/$'
    | '/$owner'
    | '/test'
    | '/installation/callback'
    | '/onboarding/$owner'
    | '/'
    | '/pulls/new'
    | '/admin'
    | '/pulls'
    | '/$owner/settings/agents'
    | '/$owner/settings/members'
    | '/$owner/settings/pull-requests'
    | '/$owner/settings/review'
    | '/$owner/settings'
    | '/$owner/$repo/pull/$number'
  id:
    | '__root__'
    | '/_authed'
    | '/waitlist'
    | '/_authed/_layout'
    | '/_authed/install'
    | '/auth/callback'
    | '/sign-in/$'
    | '/_authed/_layout/$owner'
    | '/_authed/_layout/admin'
    | '/_authed/_layout/test'
    | '/_authed/installation/callback'
    | '/_authed/onboarding/$owner'
    | '/_authed/_layout/'
    | '/_authed/_layout/$owner/settings'
    | '/_authed/_layout/pulls/new'
    | '/_authed/_layout/admin/'
    | '/_authed/_layout/pulls/'
    | '/_authed/_layout/$owner/settings/agents'
    | '/_authed/_layout/$owner/settings/members'
    | '/_authed/_layout/$owner/settings/pull-requests'
    | '/_authed/_layout/$owner/settings/review'
    | '/_authed/_layout/$owner/settings/'
    | '/_authed/_layout/$owner/$repo/pull/$number'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  WaitlistRoute: typeof WaitlistRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  SignInSplatRoute: typeof SignInSplatRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  WaitlistRoute: WaitlistRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  SignInSplatRoute: SignInSplatRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authed",
        "/waitlist",
        "/auth/callback",
        "/sign-in/$"
      ]
    },
    "/_authed": {
      "filePath": "_authed.tsx",
      "children": [
        "/_authed/_layout",
        "/_authed/install",
        "/_authed/installation/callback",
        "/_authed/onboarding/$owner"
      ]
    },
    "/waitlist": {
      "filePath": "waitlist.tsx"
    },
    "/_authed/_layout": {
      "filePath": "_authed/_layout.tsx",
      "parent": "/_authed",
      "children": [
        "/_authed/_layout/$owner",
        "/_authed/_layout/admin",
        "/_authed/_layout/test",
        "/_authed/_layout/",
        "/_authed/_layout/pulls/new",
        "/_authed/_layout/pulls/"
      ]
    },
    "/_authed/install": {
      "filePath": "_authed/install.tsx",
      "parent": "/_authed"
    },
    "/auth/callback": {
      "filePath": "auth.callback.tsx"
    },
    "/sign-in/$": {
      "filePath": "sign-in.$.tsx"
    },
    "/_authed/_layout/$owner": {
      "filePath": "_authed/_layout/$owner.tsx",
      "parent": "/_authed/_layout",
      "children": [
        "/_authed/_layout/$owner/settings",
        "/_authed/_layout/$owner/$repo/pull/$number"
      ]
    },
    "/_authed/_layout/admin": {
      "filePath": "_authed/_layout/admin.tsx",
      "parent": "/_authed/_layout",
      "children": [
        "/_authed/_layout/admin/"
      ]
    },
    "/_authed/_layout/test": {
      "filePath": "_authed/_layout/test.tsx",
      "parent": "/_authed/_layout"
    },
    "/_authed/installation/callback": {
      "filePath": "_authed/installation.callback.tsx",
      "parent": "/_authed"
    },
    "/_authed/onboarding/$owner": {
      "filePath": "_authed/onboarding.$owner.tsx",
      "parent": "/_authed"
    },
    "/_authed/_layout/": {
      "filePath": "_authed/_layout/index.tsx",
      "parent": "/_authed/_layout"
    },
    "/_authed/_layout/$owner/settings": {
      "filePath": "_authed/_layout/$owner.settings.tsx",
      "parent": "/_authed/_layout/$owner",
      "children": [
        "/_authed/_layout/$owner/settings/agents",
        "/_authed/_layout/$owner/settings/members",
        "/_authed/_layout/$owner/settings/pull-requests",
        "/_authed/_layout/$owner/settings/review",
        "/_authed/_layout/$owner/settings/"
      ]
    },
    "/_authed/_layout/pulls/new": {
      "filePath": "_authed/_layout/pulls/new.tsx",
      "parent": "/_authed/_layout"
    },
    "/_authed/_layout/admin/": {
      "filePath": "_authed/_layout/admin/index.tsx",
      "parent": "/_authed/_layout/admin"
    },
    "/_authed/_layout/pulls/": {
      "filePath": "_authed/_layout/pulls/index.tsx",
      "parent": "/_authed/_layout"
    },
    "/_authed/_layout/$owner/settings/agents": {
      "filePath": "_authed/_layout/$owner.settings/agents.tsx",
      "parent": "/_authed/_layout/$owner/settings"
    },
    "/_authed/_layout/$owner/settings/members": {
      "filePath": "_authed/_layout/$owner.settings/members.tsx",
      "parent": "/_authed/_layout/$owner/settings"
    },
    "/_authed/_layout/$owner/settings/pull-requests": {
      "filePath": "_authed/_layout/$owner.settings/pull-requests.tsx",
      "parent": "/_authed/_layout/$owner/settings"
    },
    "/_authed/_layout/$owner/settings/review": {
      "filePath": "_authed/_layout/$owner.settings/review.tsx",
      "parent": "/_authed/_layout/$owner/settings"
    },
    "/_authed/_layout/$owner/settings/": {
      "filePath": "_authed/_layout/$owner.settings/index.tsx",
      "parent": "/_authed/_layout/$owner/settings"
    },
    "/_authed/_layout/$owner/$repo/pull/$number": {
      "filePath": "_authed/_layout/$owner.$repo.pull.$number.tsx",
      "parent": "/_authed/_layout/$owner"
    }
  }
}
ROUTE_MANIFEST_END */
